import { render } from "./MainThings.vue?vue&type=template&id=bb602700&scoped=true&ts=true"
import script from "./MainThings.vue?vue&type=script&lang=ts"
export * from "./MainThings.vue?vue&type=script&lang=ts"

import "./MainThings.vue?vue&type=style&index=0&id=bb602700&scoped=true&lang=css"

import exportComponent from "/usr/home/demon/projects/driven/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb602700"]])

export default __exports__